import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { closeModal } from '../modules/active_modal';

class PriceGuideNonBundle extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { dispatch } = this.props;
    return (
      <div className="modal-window price-guide non-bundle">
        <div className="modal-close" onClick={() => dispatch( closeModal() )}>&times;</div>
        <h2>A Guide to Our Simplified Prices</h2>
        <section>
        <div className="half-col">
          <h4 className="alt2 primary-color">Member Credits:</h4>
          <p>
            Buy Member Credits during the first 10 days of the month for only ${this.props.store.one_credit} each and redeem them for any book on the site.
          </p>
          <h5 className="primary-color">(Save over 20%)</h5>
          <p>Credits will not expire, so you can use them at any time!</p>
        </div>
        </section>
        <section>
          <p>
            All pre-orders are sold at the Membership Price or for one Member Credit, and are shipped separately.
          </p>
          <p>
            <a href="/member-services" className="button btn-tertiary" onClick = {(evt) => this.props.dispatch([navigate(evt), closeModal()])}>Visit the FAQs for more details</a>
          </p>
        </section>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'store': state.store };
}

export default connect(mapStateToProps)(PriceGuideNonBundle);



// WEBPACK FOOTER //
// ./src/components/PriceGuideNonBundle.jsx